import Vuex, { Store } from "vuex";
import Vue from "vue";

Vue.use(Vuex);
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootSalesPath {}
export const store = new Vuex.Store<RootSalesPath>({
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    zipcodeMapServerInit: () => {}
  }
});

const createStore = (): Store<RootSalesPath> => {
  return store;
};

export default createStore;
